import React, { useCallback, useEffect, useRef } from 'react';
import { animate } from 'animejs';
import { AdPositionRows } from 'shared/components/AdPositionRows';
import { getRowTranslates } from './utils';
import { useDeviceType } from '@cian/ui-kit';

interface IAdPositionRowsContainerProps {
  index: number;
}

export const AdPositionRowsContainer: React.FC<IAdPositionRowsContainerProps> = ({ index }) => {
  const rowRefs = useRef<(HTMLDivElement | null)[]>([]);
  const stepYRef = useRef<number | null>(null);
  const prevIndexRef = useRef<number | undefined>(undefined);
  const animationRef = useRef<ReturnType<typeof animate> | null>(null);
  const device = useDeviceType();

  const setRowRef = useCallback(
    (rowIndex: number) => (node: HTMLDivElement | null) => {
      rowRefs.current[rowIndex] = node;
    },
    [],
  );

  useEffect(() => {
    const isFirstRun = prevIndexRef.current === undefined;

    prevIndexRef.current = index;

    if (isFirstRun) {
      return;
    }

    const rows = rowRefs.current.filter(Boolean) as HTMLDivElement[];

    if (stepYRef.current === null) {
      stepYRef.current = rows[1].getBoundingClientRect().top - rows[0].getBoundingClientRect().top;
    }

    const translates = getRowTranslates(index, stepYRef.current);

    animationRef.current?.cancel();

    animationRef.current = animate(rows, {
      duration: 400,
      ease: 'outCubic',
      translateY: (_: HTMLElement, i: number) => translates[i] ?? 0,
    });
  }, [index]);

  return <AdPositionRows setRowRef={setRowRef} device={device} />;
};
